import { useState } from 'react';
import { useRouter } from 'next/router';
import { PatternFormat } from 'react-number-format';
import axios from 'axios';
import Button from '../../Button';
import FormAgreement from '../../FormAgreement';
import { useLocationState } from '../../../context/location';
import styles from '../../../styles/modules/promotion/referral/ReferralAccess.module.scss';

const ReferralAccess = () => {
  const router = useRouter();
  const locationState = useLocationState();
  const [phone, setPhone] = useState('');
  const [error, setError] = useState(false);
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);

  const handleOnSubmit = () => {
    if (!agreeWithPolicy) {
      return;
    }

    if (phone.length !== 11) {
      setError('Пожалуйста, введите номер телефона полностью');
      return;
    }

    setError(false);

    const fetchData = async () => {
      try {
        const response = await axios.post(process.env.NEXT_PUBLIC_CRM_API + '/referral/check', {
          phone
        });

        if (response.status !== 200 || !response.data || response.data.status !== 'success')
          throw new Error(response.data.text);

        router.push(`/ref/${response.data.data.hash}`);
      } catch (error) {
        setError(error.message);
      }
    };
    fetchData();
  };

  return (
    <section className={['block', styles.block].join(' ')} id="access">
      <div className="fixed">
        <div className={styles.access}>
          <div className={styles.accessForm}>
            <h3 className={styles.accessFormTitle}>Получи ссылку для приглашения друзей</h3>
            <div className={styles.accessFormDescription}>
              Создадим для тебя персональную ссылку
            </div>
            <PatternFormat
              className={styles.accessInput}
              format="+# ### ### ## ##"
              type="tel"
              placeholder={locationState.phone}
              onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, ''))}
            />
            {error && <div className={styles.accessInputError}>{error}</div>}
            <div className={styles.accessFormDisclaimer}>
              <div>
                Вы соглашаетесь с{' '}
                <a href="/downloads/referral.pdf" target="_blank">
                  условиями акции
                </a>
                .
              </div>
              <FormAgreement onChange={setAgreeWithPolicy} button="Получить ссылку" />
            </div>
            <Button
              classes={[styles.accessButton]}
              onClick={handleOnSubmit}
              disabled={!agreeWithPolicy}
            >
              Получить ссылку
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralAccess;
